import { useHistory } from 'react-router-dom'

/**
 *
 * @param {number} idMessage
 * @returns {Function} onClick
 */
const useMessageSendAction = idMessage => {
  const history = useHistory()
  const onClick = () => {
    history.push(`/messages/email/${idMessage}/send`)
  }

  return onClick
}

export default useMessageSendAction
